module.exports = __webpack_public_path__ + "static/pec-video-image-59e02553e22a06e053ae8f53c6caba23.png";